import React, { Component } from 'react'
import { observer } from 'mobx-react'
import WeChatBind from './WeChatBind'
import YearMerchant from './YearMerchant'
import Store from './store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.store.getYearReviewStatus()
  }
  render() {
    const { showWechatDialog, yearReviewStatus } = this.store
    return (
      <>
        {showWechatDialog && <WeChatBind store={this.store} />}
        {yearReviewStatus != 0 && <YearMerchant store={this.store} />}
      </>
    )
  }
}
